/**
 * Indicates the index of the thumb in range sliders.
 */
export const index = 'data-index';
/**
 * Present while the user is dragging.
 */
export const dragging = 'data-dragging';
/**
 * Indicates the orientation of the slider.
 * @type {'horizontal' | 'vertical'}
 */
export const orientation = 'data-orientation';
/**
 * Present when the slider is disabled.
 */
export const disabled = 'data-disabled';
/**
 * Present when the slider is in a valid state (when wrapped in Field.Root).
 */
export const valid = 'data-valid';
/**
 * Present when the slider is in an invalid state (when wrapped in Field.Root).
 */
export const invalid = 'data-invalid';
/**
 * Present when the slider has been touched (when wrapped in Field.Root).
 */
export const touched = 'data-touched';
/**
 * Present when the slider's value has changed (when wrapped in Field.Root).
 */
export const dirty = 'data-dirty';
/**
 * Present when the slider is focused (when wrapped in Field.Root).
 */
export const focused = 'data-focused';
